export class Group {
    constructor(
      public id: string,
      public name: string,
      public name02: string,
      public teachers: string[],
      public teachers02: string[],
      public groups: any[],
      public deactivatedRoles: any[],
      public invisibleToMobile: boolean,
      public isGroup: boolean,
      public userTotalCount: number,
      public roles: any[],
      public building?: string,
      public buildings?: any[],
      public units?: any[],
      public description?: string,
    ) { }
  }



// WEBPACK FOOTER //
// ./src/app/settings/groups/shared/group.model.ts